export const EDIT_URL_PART = 'edit',
  ADD_NEW_URL_PART = 'new',
  SELECT_EXISTING_PART = 'select',
  PHOTOS_URL_PART = 'photos',
  POSTWALL_URL_PART = 'news',
  PRIVACY_POLICY_URL_PART = 'processing-data',
  SUBSCRIPTION_PAY_GATE_URL_PART = 'subscription-pay-gate'

